// packages/client/src/hooks/useProdutoConfig.ts
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '@/services/auth.service';

export interface ProdutoConfigVariante {
  codcor: number;
  cor: string | null;
  codtamanho: number;
  tamanho: string | null;
  ativo_venda: boolean;
}

export interface ProdutoConfig {
  ativo_venda: boolean;
  variantes: ProdutoConfigVariante[];
}

export function useProdutoConfig(produtoCodigo: number) {
  const queryClient = useQueryClient();

  const { data: config, isLoading } = useQuery<ProdutoConfig>({
    queryKey: ['produto-config', produtoCodigo],
    queryFn: async () => {
      const res = await api.get<ProdutoConfig>(`/admin/produtos/${produtoCodigo}/config`);
      return res.data;
    },
    staleTime: 30_000
  });

  const {
    mutate: patchProduto,
    isPending: isPatchingProduto,
    isError: isErrorProduto
  } = useMutation({
    mutationFn: async (ativo_venda: boolean) => {
      await api.patch(`/admin/produtos/${produtoCodigo}/config`, { ativo_venda });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['produtos-admin-catalogo'] });
    },
    // AIDEV-NOTE: onSettled (nao onSuccess) — em erro tambem re-sincroniza o estado real do server
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['produto-config', produtoCodigo] });
    }
  });

  const {
    mutate: patchVariante,
    isPending: isPatchingVariante,
    isError: isErrorVariante
  } = useMutation({
    mutationFn: async ({
      codcor,
      codtamanho,
      ativo_venda
    }: {
      codcor: number;
      codtamanho: number;
      ativo_venda: boolean;
    }) => {
      await api.patch(`/admin/produtos/${produtoCodigo}/grade/${codcor}/${codtamanho}`, {
        ativo_venda
      });
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['produto-config', produtoCodigo] });
    }
  });

  return {
    config,
    isLoading,
    patchProduto,
    patchVariante,
    isPatchingProduto,
    isPatchingVariante,
    isErrorProduto,
    isErrorVariante
  };
}
